import React, { Component } from "react";
import styles from "./Switch.local.scss";

export default class Switch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: props.isChecked
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isChecked !== this.props.isChecked) {
      this.setState({ isChecked: this.props.isChecked });
    }
  }

  render() {
    let { name } = this.props;
    // console.log("dans switch le budget est ", this.state.isChecked);
    return (
      <div className="switch-container">
        <label>
          <input
            ref="switch"
            name={name}
            checked={this.state.isChecked}
            onChange={this._handleChange}
            className={styles.ttp_switch}
            type="checkbox"
          />
          <div>
            <span>
              <i className="icon icon-toolbar grid-view" />
            </span>
            <span>
              <i className="icon icon-toolbar ticket-view" />
            </span>
            <div />
          </div>
        </label>
      </div>
    );
  }

  _handleChange = () => {
    this.setState({ isChecked: !this.state.isChecked }, () => {
      this.props.onChange(this.state.isChecked);
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/Common/Switch/Switch.js